/**
 * This is the what saves all of the time/temperature data that will ultimately be uploaded via the
 * API. Wrap this up in a class to make access slightly easier.
 */
class ActiveRoast {
  times: number[] = [];
  temps: number[][] = [[], [], [], [], []];

  addTime(time: number) {
    this.times.push(time);
  }

  addTemperatureByIndex(i: number, temp: number) {
    this.temps[i].push(temp);
  }

  addHeatingRate(value: number) {
    this.temps[4].push(value);
  }

  reset() {
    this.times = [];
    this.temps = [[], [], [], [], []];
  }
}

export default ActiveRoast;
